import { inject } from "vue";

import type { SentryNode, SentryScope } from "@/services/sentry/index.ts";

let sentryNodeInstance: SentryNode | null = null;

export const setSentryInstance = (instance: SentryNode): void => {
  sentryNodeInstance = instance;
};

export function useSentry() {
  const injectedSentry = inject<SentryNode>("$sentry", {} as SentryNode);

  const sentry = injectedSentry || sentryNodeInstance;

  if (!sentry) {
    return {
      setScope: () => {},
    };
  }

  return {
    setScope: (scope: SentryScope) => sentry.setScope(scope),
  };
}
